// React
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Libs
import Menu from 'semantic-ui-react/dist/commonjs/collections/Menu';

// Services
import { api } from '../../services/fetch/api';
import { fetchUser } from '../../services/fetch/fetchUser';

// Types
type AuthAndRefreshComponentProps = {
    onTokenChange: (t: string) => void;
};

export default function AuthAndRefreshComponent(props: AuthAndRefreshComponentProps): React.ReactElement {
    const { t } = useTranslation();
    const [token, setToken] = useState('');
    const [exp, setExp] = useState(0);
    const [countDown, setCountDown] = useState(0);

    const location = useLocation();

    function onLogout() {
        window.location.href = '/.auth/logout';
    }

    function getTokenExpiration() {
        const timer = exp - Date.now();
        const minExpDiff = 180000; // 3 minutes

        if (timer > minExpDiff) {
            setCountDown(Math.floor((timer - minExpDiff) / 1000 / 60)); // in minutes
            setTimeout(() => {
                getTokenExpiration();
            }, 1000 * 60); // a minute
        } else {
            updateToken();
        }
    }

    function updateToken() {
        // this kind of solution refreshes TOKEN, SESSION and Azure Cookie
        // main problem is / was: to get a new token, app must clear Azure cookies otherwise token will not be refreshed
        window.location.href = `${api.authUpdate}?post_login_redirect_url=${location.pathname}`;
    }

    function getToken() {
        fetchUser().then((authUser) => {
            if (authUser.redirectTo) {
                window.location.href = authUser.redirectTo;
            }

            {
                const oauth = authUser[0];

                setExp(oauth.user_claims.find((i: any) => i.typ === 'exp').val * 1000);
                setToken(oauth.id_token);
            }
        });
    }

    useEffect(() => {
        getToken();
    }, []);

    useEffect(() => {
        if (token) {
            props.onTokenChange(token);
            getTokenExpiration();
        }
    }, [token]);

    return (
        <>
            <Menu.Item
                onClick={updateToken}
                icon="refresh"
                content={t(`meta.refresh`) + ` (${countDown} min)`}></Menu.Item>
            <Menu.Item onClick={onLogout} icon="log out" content={t(`meta.logout`)}></Menu.Item>
        </>
    );
}
